window.enableSplideWheelNav = function (splide, element) {
  if (!splide || !element) return;
  if (element.__splideWheelNavBound) return;
  element.__splideWheelNavBound = true;

  const LERP = 0.15;
  const WHEEL_MULTIPLIER = 1.0;
  const IDLE_MS = 120;
  const SETTLE_EPSILON = 0.5;

  let target = null;
  let current = null;
  let bounds = null;
  let lastWheelAt = 0;
  let rafId = null;

  function resolveBounds() {
    const Move = splide.Components.Move;
    const length = splide.length;
    const perPage = splide.options.perPage || 1;
    const lastIndex = Math.max(0, length - perPage);

    // Pass trimming=true so wheel scrolling clamps to the trimmed bounds (e.g. the
    // last slide flush against the track edge). Splide only trims when the slider
    // has trimSpace enabled and is "slide" type, so this is a no-op for loop carousels.
    const a = Move.toPosition(0, true);
    const b = Move.toPosition(lastIndex, true);

    return {
      max: Math.max(a, b),
      min: Math.min(a, b),
    };
  }

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function tick() {
    const Move = splide.Components.Move;

    current += (target - current) * LERP;

    const settled = Math.abs(target - current) < SETTLE_EPSILON;
    const idle = performance.now() - lastWheelAt > IDLE_MS;

    if (settled && idle) {
      current = target;
      const nearestIndex = Move.toIndex(current);
      rafId = null;
      target = null;
      current = null;
      bounds = null;
      splide.go(nearestIndex);
      return;
    }

    Move.translate(current, true);
    rafId = requestAnimationFrame(tick);
  }

  function onWheel(event) {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

    event.preventDefault();

    if (target === null) {
      bounds = resolveBounds();
      current = splide.Components.Move.getPosition();
      target = current;
    }

    target = clamp(target - event.deltaX * WHEEL_MULTIPLIER, bounds.min, bounds.max);
    lastWheelAt = performance.now();

    if (rafId === null) {
      rafId = requestAnimationFrame(tick);
    }
  }

  function cleanup() {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    element.removeEventListener("wheel", onWheel);
    element.__splideWheelNavBound = false;
  }

  element.addEventListener("wheel", onWheel, { passive: false });

  splide.on("destroy", cleanup);
  splide.on("resize", () => {
    bounds = null;
  });
};
